import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'gis_gmp/api/'

export default {
  namespaced: true,
  state: {
    search: '',
    pagination: {
      rowsPerPage: 10,
      sortBy: null,
      totalItems: 0,
      page: 1
    },
    typeDocument: [],
    listPayer: { 'results': [] },
    payer: {},
    defaultPayer: {
      id: null,
      surname: '',
      first_name: '',
      patronymic: '',
      date_of_birth: null,
      address: '',
      type_document: null,
      series_document: '',
      number_document: ''
    }
  },
  mutations: {
    setSearch (state, payload) {
      state.search = payload
    },
    setTypeDocument (state, payload) {
      state.typeDocument = payload
    },
    setListPayer (state, payload) {
      state.listPayer = payload
    },
    setPayer (state, payload) {
      state.payer = payload
    },
    setDefaultPayer (state) {
      state.payer = Object.assign({}, state.defaultPayer)
    }
  },
  actions: {
    fetchTypeDocument ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpfetchTypeDocument'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URL + 'gis_gmp/api/type-document/'
        session.get(_url)
          .then(response => {
            commit('setTypeDocument', response.data.results)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchListPayer ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpFetchListPayer'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        if (payload.search > '') {
          params['search'] = payload.search
        }
        let _url = appURL + 'payer/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setListPayer', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchPayer ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpFetchPayer'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'payer/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setPayer', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertPayer ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpInsertPayer_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        // TODO: Код не очень
        const data = new FormData()
        data.append('surname', payload.surname)
        data.append('first_name', payload.first_name)
        data.append('date_of_birth', payload.date_of_birth)
        data.append('address', payload.address)
        data.append('type_document', payload.type_document)
        data.append('series_document', payload.series_document)
        data.append('number_document', payload.number_document)
        if (payload.patronymic) {
          data.append('patronymic', payload.patronymic)
        }
        let _url, method
        if (payload.id === null) {
          // console.log('1')
          _url = appURL + 'payer/'
          method = 'post'
        } else {
          // console.log('payload', payload)
          _url = appURL + 'payer/' + payload.id + '/'
          method = 'put'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setPayer', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deletePayer ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpDeletePayer_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'payer/' + payload + '/delete/'
        session.get(_url)
          .then(response => {
            commit('setPayer', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    search (state) {
      return state.search
    },
    pagination (state) {
      return state.pagination
    },
    typeDocument (state) {
      return state.typeDocument
    },
    listPayer (state) {
      return state.listPayer
    },
    payer (state) {
      return state.payer
    },
    getTypeDocument: (state) => (id) => {
      let item = {
        id: null,
        name: '',
        name_field_series_document: '',
        name_field_number_document: '',
        mask_series_document: '',
        mask_field_number_document: ''
      }
      for (let i in state.typeDocument) {
        if (state.typeDocument[i]['id'] === id) {
          item = state.typeDocument[i]
          break
        }
      }
      return item
    }
  }
}
